<template>
    <div class="modal-overlay">
        <div
            :class="{ 'modals modals-center': true, show: true, 'modals-import new payment-modal': true }"
            v-on-clickaway="close"
            style="z-index:1000;"
        >
            <div class="modals-head">
                <div class="modals-name">
                    <h2>Proceed with payment</h2>
                </div>
                <div class="modals-close">
                    <a @click="close" href="javascript:{}"><span class="icon-close"></span></a>
                </div>
            </div>
            <div class="modals-content">
                <div class="search-content" v-show="!showLoader">
                    <div ref="dropinarea" id="dropin-container"></div>
                    <div v-if="!disabled">
                        <div class="modals-footer">
                            <a
                                id="confirmButton"
                                ref="confirmPaymentMethodBtn"
                                :class="{ 'btn btn-primary right save-btn': true, disabled: disabled }"
                                @click="confirmPaymentMethod()"
                                >Continue</a
                            >
                        </div>
                    </div>
                </div>
                <div class="loading-container" v-show="showLoader">
                    <div id="loading"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mixin as clickaway } from "vue-clickaway";
import axios from "axios";
import { mapState } from "vuex";
import settings from "@/settings";
import router from "@/router";

export default {
    name: "payment-modal",
    props: ["shown"],
    mixins: [clickaway],
    mounted() {
        setTimeout(() => {
            this.attach_braintree();
        }, 1000);
    },
    computed: {
        ...mapState(["pricing_plans", "client_token", "user"]),
        active_pricing_row() {
            if (this.pricing_plans && this.pricing_plans.length > 0) {
                let planner = this.pricing_plans.find(f => !f.is_trial);
                return planner.pricing_row;
            }
        }
    },
    data() {
        let is_package = true;
        return {
            has_free_trial: true,
            showLoader: true,
            disabled: true,
            is_package: is_package,
            braintree_instance: null
        };
    },
    methods: {
        attach_braintree() {
            braintree.dropin.create(
                {
                    authorization: this.client_token,
                    container: "#dropin-container",
                    threeDSecure: true
                },
                (createErr, instance) => {
                    this.showLoader = false;
                    this.disabled = false;
                    this.braintree_instance = instance;
                }
            );
        },
        confirmPaymentMethod() {
            this.disabled = true;
            let threeDSecureParameters = {
                amount: this.active_pricing_row.price,
                email: this.user.email
            };
            this.braintree_instance.requestPaymentMethod({ threeDSecure: threeDSecureParameters }, (err, payload) => {
                this.showLoader = true;
                this.disabled = true;
                if (this.is_package) {
                    this.handlePackagePurchase(payload);
                }
            });
        },
        handlePackagePurchase(payload) {
            let data = {
                ...payload
            };
            data.package_pricing_row_id = this.active_pricing_row.id;
            axios.post(settings.api_url + "/payment/submit-cart", data).then(resp => {
                if (resp.data.success) {
                    router.push({ path: "/settings/subscription/success" });
                } else {
                    router.push({ path: "/settings/subscription/error" });
                }
            });
        },
        close(ce) {
            if (this.braintree_instance) {
                this.braintree_instance.teardown(err => {});
            }
            this.$nextTick(() => {
                this.$emit("close-modal");
            });
        }
    }
};
</script>
<style scoped>
.modals-footer {
    margin-top: 16px;
}

.modal-overlay {
    position: fixed; /* Stay in place */
    z-index: 132; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    overflow: auto; /* Enable scroll if needed */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

h2 {
    margin-bottom: 0rem;
    font-size: 1.6rem;
}

.modals-close {
    display: flex;
    margin-left: auto;
}

.modals-close a,
.modals-name {
    display: flex;
}

.modals-head {
    display: flex;
    border-bottom: 0.1rem solid #dbdbdb;
}

.modals-footer {
    display: flex;
    margin-bottom: 42px;
}

.modals-footer a {
    margin-left: auto;
}

.modals {
    border-radius: 4px;
    background-color: #fefefe;
    margin: 15% auto; /* 15% from the top and centered */
    border: 1px solid #888;
    width: 444px; /* Could be more or less, depending on screen size */
    max-width: 90%;
}

.modals-content,
.modals-head {
    padding: 16px;
}
</style>
